// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInfoBanner-cls1_mIy","cls2":"CiterightInfoBanner-cls2_z9l CiterightInfoBanner-cls1_mIy"};